import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import APICall from "./apiCall.js";

const relayEntityAdapter = createEntityAdapter({ selectId: ({ id }) => id });

const entitySelectors = relayEntityAdapter.getSelectors(state => state.relays );

export const relaySlice = createSlice({
    name: "relays",
    initialState: relayEntityAdapter.getInitialState({ loading: false }),
    reducers: {
        relayAdded: relayEntityAdapter.addOne,

        clear: relayEntityAdapter.removeAll,
        relaysSet: (state, action) =>{
            relayEntityAdapter.setMany(state, action.payload);
            state.loading = false
        },
        relayLoading: (state, action) => {
            state.loading = action.payload
        }
    }
});

// Actions


export function relaysFetch() {
    return async dispatch => {
        dispatch(relaySlice.actions.relayLoading(true));
        const relays = await APICall("/relays", null, null, "session")
        dispatch(relaySlice.actions.relaysSet(relays));
    }
}

export function relayCreate(host, name, port, password) {
    return async dispatch => {
        dispatch(relaySlice.actions.relayLoading(true));
        await APICall("/relays/_new", {
            host,
            name,
            port,
            password
        }, null, "session");
        await dispatch(relaysFetch());
    }
}

export function relayUpdate(id, host, name, port, password) {
    return async dispatch => {
        dispatch(relaySlice.actions.relayLoading(true));
        await APICall(`/relays/${id}`, {
            host,
            name,
            port,
            password
        }, null, "session")
        await dispatch(relaysFetch());
    }
}

export function relayDelete(id) {
    return async dispatch => {
        dispatch(relaySlice.actions.relayLoading(true));
        await APICall(`/relays/${id}/delete`, {}, null, "session");
        await dispatch(relaysFetch());
    }
}

export function relayActionSave(relayId, action) {
    return async dispatch => {
        await APICall(`relays/${relayId}/actions`, { action }, null, "session");
        await dispatch(relaysFetch());
    }
}

export function relayActionDelete(relayId, action){
    return async dispatch => {
        await APICall(`relays/${relayId}/actions/delete/${action.id}`, { }, null, "session");
        await dispatch(relaysFetch());
    }
}



// Selectors

export const selectRelays = entitySelectors.selectAll;

export const selectRelayById = entitySelectors.selectById;

export const selectRelaysLoading = state => state.relays.loading;

// Misc

export function testRelayConnection(host, port, password){
    return APICall("/relays/_test", {
        host,
        port,
        password
    }, null, "session")
}

export default relaySlice.reducer;

